<template>
  <v-list
    class="pa-0 ma-0 fonte vehicle-list"
    light
    two-line
    dense
    color="transparent"
    style="min-height: 20vh; max-height: 90vh; overflow: auto;"
  >
    <template v-for="(veiculo, i) in showFiltereds">
      <v-list-item
        :key="veiculo._id"
        @click="open(veiculo)"
        class="fonte pl-3 pr-2 my-2 animate__animated animate__fadeInUp vehicle-list-item"
      >
        <v-list-item-content>
          <v-list-item-title class="fonte-bold">
            {{ veiculo.placa }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ veiculo.modelo || "Modelo não informado" }}
          </v-list-item-subtitle>
          <v-list-item-subtitle>
            {{ veiculo.capacidade || "Capacidade não informada" }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-avatar rounded size="36" :color="veiculo.ativo ? '#e8f5e9' : '#eeeeee'">
            <v-icon :color="veiculo.ativo ? 'green' : 'grey'">mdi-truck-outline</v-icon>
          </v-avatar>
        </v-list-item-action>
      </v-list-item>
      <v-divider v-if="i < showFiltereds.length - 1" :key="i"></v-divider>
    </template>
    <v-list-item
      style="min-height: 200px;"
      v-intersect="onIntersect"
    ></v-list-item>
  </v-list>
</template>

<script>
export default {
  props: {
    filtereds: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      itemsToShow: 12
    };
  },
  computed: {
    showFiltereds() {
      return this.filtereds.slice(0, this.itemsToShow);
    }
  },
  methods: {
    onIntersect() {
      this.itemsToShow += 12;
    },
    open(veiculo) {
      this.$store.commit("set_veiculo", veiculo);
    }
  }
};
</script>

<style scoped>
.vehicle-list {
  background: transparent !important;
}

.vehicle-list-item {
  background: #f4f5f7;
  border: 1px solid #e2e6ea;
  border-radius: 6px;
  color: #263238;
  min-height: 76px;
}

.vehicle-list-item:hover {
  background: #eceff1;
}
</style>
